import { render, staticRenderFns } from "./CoursesManage.vue?vue&type=template&id=14a00498&scoped=true"
import script from "./CoursesManage.vue?vue&type=script&lang=ts"
export * from "./CoursesManage.vue?vue&type=script&lang=ts"
import style0 from "./CoursesManage.vue?vue&type=style&index=0&id=14a00498&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a00498",
  null
  
)

export default component.exports